module.exports = __webpack_public_path__ + "img/z_k@2x.ef9b83c9.png";